import {Divider} from 'antd';
import React from 'react';

const AppDivider = () => {
  return <Divider style={{margin: 0}} />;
};

export default AppDivider;
